<template>
  <div :class="{'panel panel-flat': panelized, 'full-height': fullHeight}">
    <div class="panel-heading" v-if="showHeader && panelized">
      <h6 class="panel-title">{{title}}</h6>
      <div class="heading-elements">
        <!-- ul class="icons-list">
          <li><a data-action="collapse"></a></li>
          <li><a data-action="reload"></a></li>
          <li><a data-action="close"></a></li>
        </ul -->
      </div>
    </div>

    <div :class="{'panel-body': panelized}">
      <ul class="media-list chat-list content-group scrollable" v-chat-scroll="{always: false, smooth: true}">
        <li class="media" v-for="(message, idx) in messages" :key="idx" :class="{'reversed': message.user_id === parseInt($store.getters.userId)}">
          <div v-if="!message.is_me" class="media-left" :class="{'hidden-username':hideUsernames}">
            <a class="img-avatar" href="@/assets/images/placeholder.jpg">
              <img v-if="message.user.profile.logo" :src="message.user.profile.logo.preview" class="img-sm img-circle" :alt="$formatter.formatUser(message.user)" :title="$formatter.formatUser(message.user)">
              <img v-else src="@/assets/images/placeholder.jpg" class="img-sm img-circle" :alt="$formatter.formatUser(message.user)" :title="$formatter.formatUser(message.user)">
            </a>
            <span v-if="!hideUsernames" class="media-annotation">{{$formatter.formatUser(message.user)}}</span>
          </div>

          <div class="media-body">
            <div class="media-content" :class="{'bg-grey-300': message.file}">
              <span v-if="message.html" v-html="message.html"></span>
              <span v-else>{{message.text}}</span>
              <div v-if="message.file">
                <a v-if="message.file.is_public" :href="message.file.preview" class="text-muted" :download="message.file.filename"><i class="icon-file-download"></i> {{message.file.filename}}</a>
                <a v-else class="text-muted" :download="message.file.filename" v-auth-file-download="fileService.makePrivateLink(message.file.uid)"><i class="icon-file-download"></i> {{message.file.filename}}</a>
                <div v-if="message.file.image">
                  <img v-if="message.file.image.is_public" :src="message.file.image.preview">
                  <img v-if="!message.file.image.is_public" v-auth-img="message.file.image.preview">
                </div>
              </div>
            </div>
            <span v-if="!hideUsernames" class="media-annotation display-block mt-10">{{message.created_at | moment(localizedFormat.fullDate)}}</span>
          </div>

          <div v-if="message.is_me" class="media-right" :class="{'hidden-username':hideUsernames}">
            <a class="img-avatar" href="@/assets/images/placeholder.jpg">
              <img v-if="message.user.profile.logo" :src="message.user.profile.logo.preview" class="img-sm img-circle" :alt="$formatter.formatUser(message.user)" :title="$formatter.formatUser(message.user)">
              <img v-else src="@/assets/images/placeholder.jpg" class="img-sm img-circle" :alt="$formatter.formatUser(message.user)" :title="$formatter.formatUser(message.user)">
            </a>
            <span v-if="!hideUsernames" class="media-annotation">{{$formatter.formatUser(message.user)}}</span>
          </div>

        </li>
      </ul>

      <div class="input-group">
        <span class="input-group-addon">
          <UploadForm
            accept="*/*"
            @uploadComplete="uploadComplete"
            :multiple="false"
            label=""
            labelIconClass="icon-file-plus"
            :showHint="false"
            :showButtonBg="false"
          ></UploadForm>
        </span>
        <textarea ref="chatmessage" autocomplete="nope" name="enter-message" v-model="newMessage" class="form-control" rows="1" cols="1" style="resize: none" placeholder="Enter your message..." @keyup.ctrl.enter="textMessage"></textarea>
        <span class="input-group-btn">
          <button type="button" @click="textMessage" class="btn bg-teal-400 legitRipple"><b><i class="icon-circle-right2"></i></b></button>
        </span>
      </div>

      <div class="row">
        <div class="col-xs-6">
          <ul class="icons-list icons-list-extended mt-10">
            <li>
            </li>
            <!-- li><a href="#" data-popup="tooltip" title="" data-container="body" data-original-title="Send photo"><i class="icon-file-picture"></i></a></li>
            <li><a href="#" data-popup="tooltip" title="" data-container="body" data-original-title="Send video"><i class="icon-file-video"></i></a></li>
            <li><a href="#" data-popup="tooltip" title="" data-container="body" data-original-title="Send file"><i class="icon-file-plus"></i></a></li -->
          </ul>
        </div>

        <div class="col-xs-6 text-right">

        </div>
      </div>
    </div>
    <overlay v-if="showLoader" message="Connecting..." html="<i class='icon-spinner2 icon-2x spinner'></i>" :compact="true"></overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import ChatService from '@/services/chat.service'
import Overlay from '@/components/_partial/_atomic/Overlay'
import UploadForm from '@/components/_partial/UploadForm'
import VueChatScroll from 'vue-chat-scroll'
import fileServiceMixin from '@/helpers/mixins/_fileServiceMixin'
import notificationHelper from '@/helpers/notification.helper'
Vue.use(VueChatScroll)

export default {
  name: 'Chat',
  components: { Overlay, UploadForm },
  props: {
    'showHeader': Boolean,
    'title': String,
    'slug': String,
    'panelized': {
      type: Boolean,
      default: true
    },
    'fullHeight': {
      type: Boolean,
      default: false
    },
    'hideUsernames': {
      type: Boolean,
      default: false
    }
  },
  mixins: [fileServiceMixin],
  data () {
    return {
      service: ChatService,
      chatId: null,
      newMessage: '',
      messages: [],
      ready: false,
      localizedFormat: {},
      showLoader: true
    }
  },

  mounted () {
    this.localizedFormat = Vue.config.localizedFormat
    this.enterChat()
  },

  beforeDestroy () {
    this.leaveChat()
  },

  methods: {
    enterChat () {
      this.service.createChatIfNotExists(this.slug, chatModel => {
        this.chatId = chatModel.id

        this.service.getMessages(this.chatId, null, (data) => {
          this.addMessages(data)
          this.$socket.enterChat(this.chatId).then(chat => {
            this.$socket.reconnectedCallback(this.connectToChatSocket)
            this.$socket.disconnectedCallback(this.disconnected)
            this.ready = true
            this.showLoader = false
            chat.onMessage(this.onMessage)
          })
        })
      })
    },

    addMessages (list) {
      list = list || []
      list.forEach(m => {
        m.is_me = false
        if (m.user_id === parseInt(this.$store.getters.userId)) {
          m.is_me = true
        }
        m = this.parse(m)
        this.messages.unshift(m)
      })
    },

    disconnected () {
      this.ready = false
      this.showLoader = true
    },

    connectToChatSocket () {
      this.$socket.enterChat(this.chatId).then(chat => {
        this.ready = true
        this.showLoader = false
        chat.onMessage(this.onMessage)
      })
    },

    leaveChat () {
      if (this.ready) {
        this.$socket.leaveChat(this.chatId)
      }
    },

    onUserConnected (user) {
      this.$logger.log('new user connected', user)
    },

    onMessage (message) {
      this.$logger.log('new message', message)
      this.addMessage(message, true)
    },

    parse (message) {
      if (message.data) {
        message.html = notificationHelper.toHtml(message.data.content || '', message.data.bindings || [])
      }

      return message
    },

    addMessage (message, overwrite) {
      overwrite = overwrite || false

      message.is_me = false
      if (message.user_id === parseInt(this.$store.getters.userId)) {
        message.is_me = true
      }

      let exists = false
      for (let i = this.messages.length - 1; i >= 0; i--) {
        const m = this.messages[i]
        if (m.id === message.id) {
          if (overwrite) {
            this.messages[i] = message
          }
          exists = true
          break
        }
      }

      if (!exists) {
        message = this.parse(message)
        this.messages.push(message)
      }
    },

    sendMessage (messageData, successCallback) {
      this.service.sendMessage(this.chatId, messageData, message => {
        this.addMessage(message)
        successCallback(message)
      })
    },

    textMessage () {
      if (!this.ready) {
        this.$popup.warning('Not connected')
      }
      const text = this.newMessage.trim()
      if (!text.length) {
        this.$refs.chatmessage.focus()
        return
      }

      this.sendMessage({
        text: text
      }, () => {
        this.newMessage = ''
        this.$refs.chatmessage.focus()
      })
    },

    uploadComplete (file) {
      this.sendMessage({
        file_id: file.uploaded.id
      }, () => {
        let toast = {
          'body': 'File uploaded',
          'type': 'info',
          'bodyOutputType': 'TrustedHtml'
        }
        this.$vueOnToast.pop(toast)
        // this.$notify('File uploaded', 'info')
      })
    }
  }
}
</script>

<style scoped>

</style>
